import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.number.constructor.js";
import { ref, onBeforeMount } from "vue";
var DAYS_AFTER_SHOW_AGAIN_BANNER = 90;
var msInDay = 24 * 60 * 60 * 1000;
function getDayDiff(startDate, endDate) {
  if (endDate < startDate) throw "startData can't be greater than endDate!";
  return Math.round((Number(endDate) - Number(startDate)) / msInDay);
}
export function useAppBanner() {
  var isAppBannerVisible = ref(false);
  onBeforeMount(function () {
    if (!window.localStorage.bannerClosedDate) {
      isAppBannerVisible.value = true;
      return;
    }
    try {
      if (getDayDiff(new Date(localStorage.bannerClosedDate), new Date()) < DAYS_AFTER_SHOW_AGAIN_BANNER) return;
      //After 90 days I'll show the banner again to the user
      window.localStorage.removeItem("bannerClosedDate");
      isAppBannerVisible.value = true;
    } catch (error) {
      console.error(error);
    }
  });
  return {
    isAppBannerVisible: isAppBannerVisible
  };
}